/** Erros das bibliotecas de autenticação e HTTP que não passam pela API Nest. */
const ERROR_MESSAGES: Record<string, string> = {
  INVALID_EMAIL_OR_PASSWORD: 'E-mail ou senha incorretos.',
  INVALID_PASSWORD: 'Senha incorreta.',
  INVALID_EMAIL: 'Informe um e-mail válido.',
  INVALID_USER: 'Usuário inválido.',
  USER_NOT_FOUND: 'Usuário não encontrado.',
  USER_ALREADY_EXISTS: 'Já existe uma conta com este e-mail.',
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: 'Já existe uma conta com este e-mail.',
  EMAIL_NOT_VERIFIED: 'Confirme seu e-mail para continuar.',
  PASSWORD_TOO_SHORT: 'A senha é muito curta.',
  PASSWORD_TOO_LONG: 'A senha é muito longa.',
  CREDENTIAL_ACCOUNT_NOT_FOUND:
    'Esta conta usa login com Google. Entre com Google para continuar.',
  INVALID_TOKEN: 'Link inválido ou expirado. Solicite um novo link.',
  TOKEN_EXPIRED: 'Link expirado. Solicite um novo link.',
  SESSION_EXPIRED: 'Sessão expirada. Faça login novamente.',
  SESSION_NOT_FRESH: 'Faça login novamente para realizar esta ação.',
  INVALID_SESSION: 'Sessão inválida. Faça login novamente.',
  FAILED_TO_CREATE_USER: 'Não foi possível criar a conta. Tente novamente.',
  FAILED_TO_CREATE_SESSION:
    'Não foi possível iniciar a sessão. Tente novamente.',
  FAILED_TO_UPDATE_USER: 'Não foi possível atualizar a conta. Tente novamente.',
  FAILED_TO_GET_SESSION:
    'Não foi possível verificar a sessão. Faça login novamente.',
  SOCIAL_ACCOUNT_ALREADY_LINKED: 'Esta conta já está vinculada.',
  ACCOUNT_NOT_FOUND: 'Conta não encontrada.',
  PROVIDER_NOT_FOUND: 'Forma de login não disponível.',
  FAILED_TO_GET_USER_INFO:
    'Não foi possível obter os dados da conta. Tente novamente.',
  USER_EMAIL_NOT_FOUND: 'E-mail da conta não encontrado.',
  EMAIL_CAN_NOT_BE_UPDATED: 'Não é possível alterar o e-mail desta conta.',
  CHANGE_EMAIL_DISABLED: 'A alteração de e-mail está desativada.',
  FAILED_TO_UNLINK_LAST_ACCOUNT:
    'Não é possível desvincular a última forma de acesso à conta.',
  USER_ALREADY_HAS_PASSWORD: 'Informe sua senha atual para excluir a conta.',
  EMAIL_ALREADY_VERIFIED: 'Este e-mail já foi confirmado.',
  EMAIL_MISMATCH: 'O e-mail informado não corresponde ao da conta.',
  LINKED_ACCOUNT_ALREADY_EXISTS: 'Esta conta já está vinculada.',
  PASSWORD_ALREADY_SET: 'Esta conta já possui uma senha.',
  VALIDATION_ERROR: 'Verifique os dados informados e tente novamente.',
  MISSING_FIELD: 'Preencha os campos obrigatórios.',
  OTP_NOT_ENABLED: 'A verificação por código não está ativada.',
  OTP_HAS_EXPIRED: 'Código de verificação expirado. Solicite um novo código.',
  TOTP_NOT_ENABLED:
    'A verificação pelo aplicativo autenticador não está ativada.',
  TWO_FACTOR_NOT_ENABLED: 'A autenticação em duas etapas não está ativada.',
  BACKUP_CODES_NOT_ENABLED: 'Os códigos de recuperação não estão ativados.',
  INVALID_BACKUP_CODE: 'Código de recuperação inválido.',
  INVALID_CODE: 'Código de verificação inválido.',
  TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE:
    'Muitas tentativas. Solicite um novo código de verificação.',
  ACCOUNT_ALREADY_LINKED_TO_DIFFERENT_USER:
    'Esta conta já está vinculada a outro usuário.',
  INVALID_CREDENTIALS: 'Dados de acesso incorretos.',
  INVALID_OTP: 'Código de verificação inválido.',
  OTP_EXPIRED: 'Código de verificação expirado. Solicite um novo código.',
  INVALID_TWO_FACTOR_COOKIE: 'Verificação expirada. Faça login novamente.',
  TOO_MANY_ATTEMPTS: 'Muitas tentativas. Aguarde um momento e tente novamente.',
  'Invalid email or password': 'E-mail ou senha incorretos.',
  'Invalid password': 'Senha incorreta.',
  'Invalid email': 'Informe um e-mail válido.',
  'User not found': 'Usuário não encontrado.',
  'User already exists': 'Já existe uma conta com este e-mail.',
  'Email not verified': 'Confirme seu e-mail para continuar.',
  'Password too short': 'A senha é muito curta.',
  'Password too long': 'A senha é muito longa.',
  'Credential account not found':
    'Esta conta usa login com Google. Entre com Google para continuar.',
  'Invalid token': 'Link inválido ou expirado. Solicite um novo link.',
  'Token expired': 'Link expirado. Solicite um novo link.',
  'Session expired': 'Sessão expirada. Faça login novamente.',
  'Bad Request': 'Verifique os dados informados e tente novamente.',
  Unauthorized: 'Faça login para continuar.',
  Forbidden: 'Você não tem permissão para realizar esta ação.',
  'Not Found': 'Recurso não encontrado.',
  Conflict: 'Esta operação entra em conflito com o estado atual do registro.',
  'Internal server error': 'Erro no servidor. Tente novamente em instantes.',
  'Internal Server Error': 'Erro no servidor. Tente novamente em instantes.',
  'Validation failed': 'Verifique os dados informados e tente novamente.',
}

const STATUS_MESSAGES: Record<number, string> = {
  400: 'Verifique os dados informados e tente novamente.',
  401: 'Faça login para continuar.',
  403: 'Você não tem permissão para realizar esta ação.',
  404: 'Recurso não encontrado.',
  409: 'Esta operação entra em conflito com o estado atual do registro.',
  413: 'Arquivo ou requisição excede o tamanho permitido.',
  422: 'Verifique os dados informados e tente novamente.',
  429: 'Muitas requisições. Aguarde um momento e tente novamente.',
}

function firstMessage(value: unknown): string | undefined {
  if (typeof value === 'string') return value.trim() || undefined
  if (Array.isArray(value)) {
    for (const item of value) {
      const message = firstMessage(item)
      if (message) return message
    }
  }
  if (value && typeof value === 'object' && 'message' in value) {
    return firstMessage(value.message)
  }
}

/** Mantém mensagens específicas em pt-BR e traduz os erros padrão de terceiros. */
export function resolveErrorResponseMessage(
  data: unknown,
  status: number,
  fallback = 'Erro inesperado. Tente novamente.'
): string {
  if (status >= 500) return 'Erro no servidor. Tente novamente em instantes.'
  if (status === 429) return STATUS_MESSAGES[429] ?? fallback

  const body =
    data && typeof data === 'object'
      ? (data as { code?: unknown; error?: unknown; message?: unknown })
      : undefined
  const code = firstMessage(body?.code) ?? firstMessage(body?.error)
  const codeMessage =
    code && Object.hasOwn(ERROR_MESSAGES, code)
      ? ERROR_MESSAGES[code]
      : undefined
  if (code && /^[A-Z][A-Z_]+$/.test(code) && codeMessage) {
    return codeMessage
  }
  // O Better Auth usa `code`; novos códigos ainda sem tradução específica
  // recebem uma mensagem em português, sem expor o texto interno em inglês.
  if (typeof body?.code === 'string' && !codeMessage) {
    return STATUS_MESSAGES[status] ?? fallback
  }

  const message = firstMessage(body?.message ?? data)
  if (message) {
    const translated = Object.hasOwn(ERROR_MESSAGES, message)
      ? ERROR_MESSAGES[message]
      : undefined
    if (translated) return translated
    // Compatibilidade com validações da API anterior durante o deploy.
    if (
      /^[\w.[\]]+: (?:Invalid|Too (?:small|big)|Required|Expected)\b/.test(
        message
      )
    ) {
      return STATUS_MESSAGES[400] ?? fallback
    }
    if (!/^[A-Z][A-Z_]+$/.test(message)) return message
  }
  if (codeMessage) return codeMessage
  return STATUS_MESSAGES[status] ?? fallback
}
